export default {
  title: 'Ce restaurant ne peut pas encore être mis en ligne',
  description:
    'Votre compte partenaire n’a défini aucun frais de traitement pour les paiements en ligne et n’a pas confirmé de marge de 0 %. Stripe facture ses frais à votre plateforme : l’un des deux doit donc être décidé au préalable.',
  partner_action:
    'Définissez des frais de traitement par défaut, ou confirmez que vous n’en facturez aucun à vos restaurants et que vous payez vous-même les frais de Stripe.',
  ask_partner:
    'Votre partenaire n’a pas encore défini ses frais de traitement pour les paiements en ligne. Ce restaurant pourra être mis en ligne dès que ce sera fait.',
  buttons: {
    set_rate: 'Définir les frais de traitement',
    close: 'Fermer',
  },
};
